import React, { useState } from 'react';
import { 
  LayoutDashboard, Video, Sparkles, Wrench, 
  Folder, FileStack, CreditCard, Settings, 
  Crown, Zap, MessageSquare, Upload, Mic
} from 'lucide-react';

export default function MimisDashboard() {
  const [activeChat, setActiveChat] = useState("");

  return (
    <div className="min-h-screen bg-[#08080A] text-white flex font-['Geist']">
      {/* SIDEBAR - MIMIS ECOSYSTEM */}
      <div className="w-[280px] shrink-0 border-r border-white/[0.06] p-6 flex flex-col">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-12 h-12 bg-white rounded-xl p-1.5 flex items-center justify-center">
            <img src="/logo_Mimis_per_social.jpg" alt="MIMIS" className="w-full h-full object-contain" />
          </div>
          <div>
            <div className="text-lg font-black leading-none">MIMIS</div>
            <div className="text-[10px] tracking-[0.3em] text-white/50">ECOSYSTEM</div>
          </div>
          <div className="ml-auto px-2 py-1 rounded-full bg-white/[0.08] border border-white/[0.08] text-[10px]">PRO</div>
        </div>

        {/* ARI CARD - SUPER IN EVIDENZA */}
        <div className="relative overflow-hidden rounded-[20px] p-[1px] mb-8 group">
          <div className="absolute inset-0 bg-gradient-to-br from-violet-500 via-fuchsia-500 to-cyan-400 opacity-80 group-hover:opacity-100 transition-opacity"></div>
          <div className="relative rounded-[19px] bg-[#15151A] p-4">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-gradient-to-br from-violet-500 to-cyan-400 flex items-center justify-center animate-pulse">
                <Sparkles size={18} />
              </div>
              <div className="flex-1">
                <div className="font-bold text-[13px] flex items-center gap-2">
                  ARI <span className="w-2 h-2 bg-emerald-400 rounded-full animate-ping"></span>
                </div>
                <div className="text-[11px] text-white/60">Il tuo assistente è online</div>
              </div>
            </div>
            <div className="mt-3 text-[12px] leading-[1.5] text-white/70">
              "Ciao! Cosa sblocchiamo oggi in MIMIS?"
            </div>
          </div>
        </div>

        {/* MENU */}
        <div className="space-y-6 flex-1">
          <div>
            <div className="text-[10px] tracking-widest text-white/30 mb-3">PIATTAFORMA</div>
            <div className="space-y-1">
              <div className="flex items-center gap-3 px-3 py-2.5 rounded-xl bg-white text-black font-medium">
                <LayoutDashboard size={18}/> Dashboard
              </div>
              <div className="flex items-center gap-3 px-3 py-2.5 rounded-xl text-white/60 hover:bg-white/[0.06] hover:text-white cursor-pointer transition">
                <Video size={18}/> Video Studio <span className="ml-auto text-[10px] bg-white/10 px-2 py-0.5 rounded-full">NEW</span>
              </div>
              <div className="flex items-center gap-3 px-3 py-2.5 rounded-xl text-white/60 hover:bg-white/[0.06] hover:text-white cursor-pointer transition">
                <Wrench size={18}/> Sblocco Digitale
              </div>
              <div className="flex items-center gap-3 px-3 py-2.5 rounded-xl text-white/60 hover:bg-white/[0.06] hover:text-white cursor-pointer transition">
                <Folder size={18}/> I Miei Progetti
              </div>
            </div>
          </div>

          <div>
            <div className="text-[10px] tracking-widest text-white/30 mb-3">RISORSE</div>
            <div className="space-y-1">
              <div className="flex items-center gap-3 px-3 py-2.5 rounded-xl text-white/60 hover:bg-white/[0.06] hover:text-white cursor-pointer">
                <FileStack size={18}/> Templates
              </div>
              <div className="flex items-center gap-3 px-3 py-2.5 rounded-xl text-white/60 hover:bg-white/[0.06] hover:text-white cursor-pointer">
                <CreditCard size={18}/> Billing
              </div>
              <div className="flex items-center gap-3 px-3 py-2.5 rounded-xl text-white/60 hover:bg-white/[0.06] hover:text-white cursor-pointer">
                <Settings size={18}/> Settings
              </div>
            </div>
          </div>
        </div>

        {/* USER + UPGRADE */}
        <div className="mt-auto p-3 rounded-2xl bg-gradient-to-br from-white/[0.08] to-white/[0.02] border border-white/[0.06]">
          <div className="flex items-center gap-2 text-[12px]"><Crown size={14} className="text-yellow-400"/> Piano PRO - 40 video</div>
          <div className="w-full h-1.5 bg-white/10 rounded-full mt-2 overflow-hidden">
            <div className="h-full w-[65%] bg-white rounded-full"></div>
          </div>
          <div className="text-[10px] text-white/40 mt-1">26 / 40 video usati</div>
        </div>
      </div>

      {/* MAIN - ARI CENTER */}
      <div className="flex-1 flex flex-col bg-[radial-gradient(ellipse_at_top,_rgba(120,80,255,0.15),transparent_60%)]">
        {/* TOP BAR */}
        <div className="h-[64px] border-b border-white/[0.06] flex items-center justify-between px-8">
          <div className="flex items-center gap-2 text-sm text-white/60">
            <span className="text-white font-medium">MIMIS Dashboard</span> <span>/</span> <span className="flex items-center gap-2"><Sparkles size={14} className="text-violet-400"/> ARI Assistant</span>
          </div>
          <div className="flex items-center gap-3">
            <div className="px-3 py-1.5 rounded-full bg-emerald-500/10 border border-emerald-500/20 text-emerald-400 text-[12px] flex items-center gap-2">
              <div className="w-2 h-2 bg-emerald-400 rounded-full animate-pulse"></div> ARI Online - Costo: 0,03€/chat
            </div>
          </div>
        </div>

        {/* ARI CHAT HERO - FUTURISTICO */}
        <div className="flex-1 flex flex-col items-center justify-center p-10">
          <div className="w-full max-w-[760px]">
            {/* ARI AVATAR GRANDE */}
            <div className="flex flex-col items-center mb-10">
              <div className="relative">
                <div className="absolute -inset-10 bg-gradient-to-br from-violet-600/30 via-fuchsia-500/20 to-cyan-400/30 blur-[40px] rounded-full"></div>
                <div className="relative w-24 h-24 rounded-[28px] bg-gradient-to-br from-violet-500 to-cyan-400 flex items-center justify-center shadow-[0_0_40px_rgba(139,92,246,0.5)]">
                  <span className="text-3xl font-black tracking-tighter">A</span>
                </div>
              </div>
              <h1 className="text-[36px] font-bold tracking-tight mt-6">Ciao, sono ARI.</h1>
              <p className="text-white/50 text-[15px] mt-2 text-center max-w-[480px]">
                L'assistente di <span className="text-white font-medium">MIMIS</span> che risolve tutto. 
                Non cercare tutorial. Risolviamo insieme.
              </p>
            </div>

            {/* QUICK ACTIONS */}
            <div className="grid grid-cols-3 gap-3 mb-8">
              {[
                {icon: <CreditCard/>, title:"Stripe non funziona", desc:"Collega pagamenti"},
                {icon: <Zap/>, title:"Emergent Deploy", desc:"Metti online il sito"},
                {icon: <Video/>, title:"Shopify Setup", desc:"Configura store"},
              ].map((item,i)=>(
                <div key={i} className="group p-4 rounded-2xl bg-white/[0.04] border border-white/[0.06] hover:bg-white/[0.08] hover:border-violet-500/30 cursor-pointer transition-all">
                  <div className="w-8 h-8 rounded-lg bg-white/[0.08] flex items-center justify-center mb-3 group-hover:bg-violet-500/20 transition">{item.icon}</div>
                  <div className="text-[13px] font-medium">{item.title}</div>
                  <div className="text-[11px] text-white/40">{item.desc}</div>
                </div>
              ))}
            </div>

            {/* INPUT ARI - FUTURISTICO */}
            <div className="relative group">
              <div className="absolute -inset-[1px] bg-gradient-to-r from-violet-500 via-fuchsia-500 to-cyan-400 rounded-[24px] opacity-50 group-focus-within:opacity-100 blur-[1px] transition"></div>
              <div className="relative flex items-center gap-3 p-2 rounded-[22px] bg-[#121216] border border-white/[0.06]">
                <div className="w-10 h-10 rounded-full bg-white/[0.06] flex items-center justify-center ml-1">
                  <Upload size={18} className="text-white/60"/>
                </div>
                <input 
                  value={activeChat}
                  onChange={(e)=>setActiveChat(e.target.value)}
                  placeholder="Carica screenshot o descrivi il problema... ARI risolve in MIMIS"
                  className="flex-1 bg-transparent outline-none text-[14px] placeholder:text-white/30"
                />
                <div className="flex items-center gap-2 mr-1">
                  <div className="w-9 h-9 rounded-full bg-white/[0.06] flex items-center justify-center cursor-pointer hover:bg-white/[0.1]"><Mic size={16}/></div>
                  <div className="w-10 h-10 rounded-full bg-white text-black flex items-center justify-center cursor-pointer hover:bg-white/90 font-bold">↗</div>
                </div>
              </div>
            </div>

            <div className="flex items-center justify-center gap-2 mt-4 text-[11px] text-white/30">
              <MessageSquare size={12}/> MIMIS Ecosystem • ARI integrato • Costo per te: ~0,03€ a chat • Margine 90%
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}